export type AddDocumentKind = 'upload' | 'google_doc' | 'google_sheet' | 'drive_link';

export type PendingDelete =
  | { kind: 'folder-hide'; id: string; name: string }
  | { kind: 'folder-delete'; id: string; name: string }
  | { kind: 'document'; id: string; name: string }
  | { kind: 'bulk'; ids: string[]; count: number };

export const DOCUMENT_UPLOAD_ACCEPT =
  '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.png,.jpg,.jpeg,.gif,.webp,application/pdf';
